// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2rmEO","disabled":"FileBtn_disabled__3g0lg","warn":"FileBtn_warn__D225T","fade":"FileBtn_fade__17z0c"};